import React from "react";
const IconUneditable = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 10C5 7.23858 7.23858 5 10 5C10.6789 5 11.3262 5.13531 11.9164 5.38042L13.411 3.88583C12.4017 3.3216 11.2384 3 10 3C6.13401 3 3 6.13401 3 10C3 11.2384 3.3216 12.4017 3.88583 13.411L5.38041 11.9164C5.1353 11.3262 5 10.6789 5 10ZM8.14881 14.6461L6.64811 16.1468C7.64356 16.6908 8.78567 17 10 17C13.866 17 17 13.866 17 10C17 8.78567 16.6908 7.64356 16.1468 6.64811L14.6461 8.14881C14.8744 8.72135 15 9.34602 15 10C15 12.7614 12.7614 15 10 15C9.34601 15 8.72135 14.8744 8.14881 14.6461ZM5.44028 15.3114L4.68863 14.5597C4.91986 14.8288 5.17118 15.0801 5.44028 15.3114Z"
      fill="currentColor"
    />
    <path
      d="M4.08594 15.957L10.0859 9.95703L16.0859 3.95703"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconUneditable;
